import { render, staticRenderFns } from "./editor_mode_switcher.vue?vue&type=template&id=583cb273"
import script from "./editor_mode_switcher.vue?vue&type=script&lang=js"
export * from "./editor_mode_switcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports